export interface Logger {
  isDebugEnabled(): boolean
  debug(message: string, ...args: unknown[]): void

  isInfoEnabled(): boolean
  info(message: string, ...args: unknown[]): void

  isWarnEnabled(): boolean
  warn(message: string, ...args: unknown[]): void

  isErrorEnabled(): boolean
  error(message: string, ...args: unknown[]): void

  child(tag: string): Logger
}

class NoopLogger implements Logger {
  isDebugEnabled(): boolean {
    return false
  }
  debug(): void {}
  isInfoEnabled(): boolean {
    return false
  }
  info(): void {}
  isWarnEnabled(): boolean {
    return false
  }
  warn(): void {}
  isErrorEnabled(): boolean {
    return false
  }
  error(): void {}
  child(): Logger {
    return new NoopLogger()
  }
}

export function createNoopLogger(): Logger {
  return new NoopLogger()
}
